import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'
import LogoTitle from '../../molecules/LogoTitle'
import ScoreCheckPinCodeTemplate from '../../templates/ScoreCheckPinCodeTemplate'
import medias from '../../../util/medias'

const ContentWrapper = styled(View)`
  padding: 24px 16px;
  ${medias.desktop`
    padding: 24px 56px;
  `}

  ${({ modalMode }) => modalMode && `padding: 0 !important;`}
`

export const ScoreCheckPinCodePage = ({
  email,
  token,
  flow,
  onSuccess,
  onResend,
  onSwitchEmail,
  onAccountNotValidated,
  onPhoneNotValidated,
  abTests,
  sessionTokens,
  modalMode,
}) => (
  <ContentWrapper modalMode={modalMode}>
    <LogoTitle title="Autenticação em duas etapas" />
    <ScoreCheckPinCodeTemplate
      email={email}
      token={token}
      flow={flow}
      onSuccess={onSuccess}
      onResend={onResend}
      onSwitchEmail={onSwitchEmail}
      onAccountNotValidated={onAccountNotValidated}
      onPhoneNotValidated={onPhoneNotValidated}
      abTests={abTests}
      sessionTokens={sessionTokens}
      modalMode={modalMode}
    />
  </ContentWrapper>
)

ScoreCheckPinCodePage.propTypes = {
  email: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  flow: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
  onResend: PropTypes.func,
  onSwitchEmail: PropTypes.func,
  onAccountNotValidated: PropTypes.func,
  onPhoneNotValidated: PropTypes.func,
  abTests: PropTypes.string,
  sessionTokens: PropTypes.object,
  modalMode: PropTypes.bool,
}
